/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

import { getStoreConfig } from '@/auth/api';
import { useEffect, useState } from 'preact/hooks';
import { StoreConfigModel } from '../../data/models';

export const useGetStoreConfigs = () => {
  const [isEmailConfirmationRequired, setIsEmailConfirmationRequired] =
    useState(false);
  const [passwordConfigs, setPasswordConfigs] = useState<{
    minLength: number;
    requiredCharacterClasses: number;
  } | null>(null);

  useEffect(() => {
    const storeConfigString = sessionStorage.getItem('storeConfig');

    const cachedStoreConfig: StoreConfigModel = storeConfigString
      ? JSON.parse(storeConfigString)
      : null;

    if (cachedStoreConfig) {
      const { minLength, requiredCharacterClasses, createAccountConfirmation } =
        cachedStoreConfig;

      setPasswordConfigs({
        minLength,
        requiredCharacterClasses,
      });

      setIsEmailConfirmationRequired(createAccountConfirmation);
    } else {
      getStoreConfig().then((response) => {
        if (response) {
          const {
            minLength,
            requiredCharacterClasses,
            createAccountConfirmation,
          } = response;

          sessionStorage.setItem('storeConfig', JSON.stringify(response));

          setPasswordConfigs({
            minLength,
            requiredCharacterClasses,
          });

          setIsEmailConfirmationRequired(createAccountConfirmation);
        }
      });
    }
  }, []);

  return { passwordConfigs, isEmailConfirmationRequired };
};
